/*
    Display for an individual delay report record
*/

import React from "react";

import DataItem from "../Components/DataItem";
export default class ReportDelayData extends React.Component {
    render(){
        return(
            <div className="data" style={{
                display: "grid",
                gridTemplateColumns: "1fr 2fr 1fr",
                padding: "8px 0 8px 32px"
            }}>
                <div>Date: <DataItem val={this.props.data.SchedDate} /></div>
                <div>Delay Reason: <DataItem val={this.props.data.DelayReason} /></div>
                <div>Total: <DataItem val={this.props.data.Total} /></div>
            </div>
        )
    }
}